import { render, staticRenderFns } from "./doc-tabs.vue?vue&type=template&id=75985e89&"
import script from "./doc-tabs.vue?vue&type=script&lang=js&"
export * from "./doc-tabs.vue?vue&type=script&lang=js&"
import style0 from "./doc-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports